import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=dae86bae"
import script from "./CreateCategory.vue?vue&type=script&lang=js"
export * from "./CreateCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateCategory.vue?vue&type=style&index=0&id=dae86bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports